import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1022KtoDupStatus: 'idle',
    startProcess1022KtoDupError: undefined as any,
    loadUserParamsProcess1022KtoDupStatus: 'idle',
    loadUserParamsProcess1022KtoDupError: undefined as any,

    process1022KtoDupList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1022KtoDup = createAsyncThunk('process1022KtoDupSlice/startProcess1022KtoDup', async ({ process1022KtoDup }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1022KtoDup/`,
        prepareData(process1022KtoDup),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1022KtoDupStatus } = getState().process1022KtoDupSlice
        return startProcess1022KtoDupStatus !== 'pending'
    }
})

export const loadUserParamsProcess1022KtoDup = createAsyncThunk('process1022KtoDupSlice/loadUserParamsProcess1022KtoDup', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1022KtoDup/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1022KtoDupStatus } = getState().process1022KtoDupSlice
        return loadUserParamsProcess1022KtoDupStatus !== 'pending'
    }
})

const Process1022KtoDupSlice = createSlice({
    name: 'process1022KtoDupSlice',
    initialState,
    reducers: {
        resetstartProcess1022KtoDup: (state) => {
            state.job = undefined
            state.startProcess1022KtoDupError = undefined
        },
        resetstartProcess1022KtoDupError: (state) => {
            state.startProcess1022KtoDupError = undefined
        },
        resetloadUserParamsProcess1022KtoDup: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1022KtoDupError = undefined
        },
        resetloadUserParamsProcess1022KtoDupError: (state) => {
            state.loadUserParamsProcess1022KtoDupError = undefined
        },
        removeFromProcess1022KtoDupListById: (state, action) => {
            state.process1022KtoDupList = state.process1022KtoDupList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1022KtoDupListByIds: (state, action) => {
            state.process1022KtoDupList = state.process1022KtoDupList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1022KtoDupList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1022KtoDupStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1022KtoDupList = []
            state.startProcess1022KtoDupStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1022KtoDup.pending, (state) => {
            state.startProcess1022KtoDupStatus = 'pending'
            state.startProcess1022KtoDupError = undefined
        })
        builder.addCase(startProcess1022KtoDup.fulfilled, (state, action) => {
            state.startProcess1022KtoDupStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1022KtoDup.rejected, (state, action) => {
            state.startProcess1022KtoDupStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1022KtoDupError = action.error.message
            } else {
                state.startProcess1022KtoDupError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1022KtoDup.pending, (state) => {
            state.loadUserParamsProcess1022KtoDupStatus = 'pending'
            state.loadUserParamsProcess1022KtoDupError = undefined
        })
        builder.addCase(loadUserParamsProcess1022KtoDup.fulfilled, (state, action) => {
            state.loadUserParamsProcess1022KtoDupStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1022KtoDup.rejected, (state, action) => {
            state.loadUserParamsProcess1022KtoDupStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1022KtoDupError = action.error.message
            } else {
                state.loadUserParamsProcess1022KtoDupError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1022KtoDup,
    resetstartProcess1022KtoDupError,
    resetloadUserParamsProcess1022KtoDup,
    resetloadUserParamsProcess1022KtoDupError,
    removeFromProcess1022KtoDupListById,
    removeFromProcess1022KtoDupListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1022KtoDupSlice.actions
export default Process1022KtoDupSlice.reducer
